<div class="d-flex justify-content-end pb-4">
    <button
        *ngIf="isOnEdit"
        (click)="cancelChanges()"
        type="button"
        class="btn btn-outline-secondary font-weight-bold font-size-14 px-4 py-2 mr-4 selenium-cancel-edit-btn"
    >
        Cancel
    </button>
    <button
        (click)="toggleEditForm()"
        [disabled]="isDisabled"
        type="button"
        class="btn btn-primary font-weight-bold font-size-14 px-4 py-2 selenium-edit-or-save-btn"
    >
        {{ isOnEdit ? "Save Changes" : "Edit" }}
    </button>
</div>
